import React from "react";
import { visuallyHidden } from "@mui/utils";

// mui components
import {
	Box,
	Stack,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
} from "@mui/material";

// custom components
import Heading5 from "../../typography/heading-05";

// helper functions
import { sortAmount, sortDate, sortNumber } from "../../../utils/sort-methods";

// custom styles
import styles from "./index.module.scss";

const TableHeadEnhancedConditionTracking = (props) => {
	const {
		data,
		// sort
		order,
		orderBy,
		onRequestSort,
		filteredLoans,
		setFilteredLoans,
	} = props;

	const createSortHandler = (property) => (event) => {
		const sortConfigMap = {
			condition: {
				field: "__enhancedConditionSortTitle",
				sort: sortAmount,
			},
			status: {
				field: "__enhancedConditionSortStatus",
				sort: sortAmount,
			},
			category: {
				field: "__enhancedConditionSortCategory",
				sort: sortAmount,
			},
			"prior to": {
				field: "__enhancedConditionSortPriorTo",
				sort: sortAmount,
			},
			source: {
				field: "__enhancedConditionSortSource",
				sort: sortAmount,
			},
			added: {
				field: "__enhancedConditionSortAdded",
				sort: sortDate,
			},
			docs: {
				field: "__enhancedConditionSortDocs",
				sort: sortNumber,
			},
		};

		const sortConfig = sortConfigMap[property];

		if (!sortConfig) {
			onRequestSort(event, property);
			return;
		}

		const rowsToSort = Array.isArray(filteredLoans) ? [...filteredLoans] : [];
		const rowsWithSortValues = rowsToSort.map((row) => ({
			...row,
			__enhancedConditionSortTitle:
				row?.title ?? row?.name ?? row?.conditionTitle ?? "",
			__enhancedConditionSortStatus: row?.sub_status ?? row?.status ?? "",
			__enhancedConditionSortCategory: row?.category ?? "",
			__enhancedConditionSortPriorTo: row?.priorTo ?? "",
			__enhancedConditionSortSource: row?.source ?? row?.sourceOfCondition ?? "",
			__enhancedConditionSortAdded:
				row?.createdDate ?? row?.statusDate ?? "",
			__enhancedConditionSortDocs: Number(row?.count_of_doc ?? 0),
		}));

		const sortedData =
			sortConfig.sort === sortDate
				? sortDate(rowsWithSortValues, order, sortConfig.field)
				: sortConfig.sort(rowsWithSortValues, order, sortConfig.field);

		setFilteredLoans(sortedData);
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{data.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.align}
						padding={headCell.disablePadding ? "none" : "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
						style={{
							width: headCell.minWidth,
							verticalAlign: "text-top",
						}}
					>
						<Stack direction="column" className={styles.headerStack}>
							<TableSortLabel
								active={orderBy === headCell.id}
								direction={orderBy === headCell.id ? order : "asc"}
								onClick={createSortHandler(headCell.id)}
								className={styles.tableLabelLeft}
							>
								<Heading5
									text={headCell.label}
									extraClass={styles.thText}
									fontType="semibold"
								/>
								{orderBy === headCell.id ? (
									<Box component="span" sx={visuallyHidden}>
										{order === "desc"
											? "sorted descending"
											: "sorted ascending"}
									</Box>
								) : null}
							</TableSortLabel>
						</Stack>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
};

export default TableHeadEnhancedConditionTracking;
